var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { useState, useEffect, useRef } from 'react';
export var getTimeDiffs = function (latestTime) {
    if (latestTime === null || latestTime === undefined) {
        return null;
    }
    var currentTime = new Date().getTime();
    var timeDiffInMinutes = (currentTime - Number(latestTime)) / (1000 * 60);
    // console.log('timeDiffInMinutes', timeDiffInMinutes, new Date(Number(latestTime)));
    return timeDiffInMinutes;
};
function convertTimeToAmPm(time) {
    var _a = __read(time.split(':'), 2), hours = _a[0], minutes = _a[1];
    var isAM = hours < 12 || hours === '00';
    var convertedHours = hours % 12 || 12;
    return "".concat(convertedHours, ":").concat(minutes, " ").concat(isAM ? 'AM' : 'PM');
}
export function useCounter(key) {
    var emailSentTime = localStorage.getItem(key);
    var _a = __read(useState(emailSentTime === undefined ?
        false : getTimeDiffs(emailSentTime) >= 3 ? false : getTimeDiffs(emailSentTime)), 2), status = _a[0], setStatus = _a[1];
    var timerRef = useRef(null);
    // const [countdown, setCountdown] = useState<number | null>(null);
    var startTimer = function () {
        var LatestEmailSentTime = localStorage.getItem(key);
        if (status === false || status < 3) {
            var timeDiffInMinutes = getTimeDiffs(LatestEmailSentTime);
            setStatus(timeDiffInMinutes < 3 ? timeDiffInMinutes : false);
            timerRef.current = setInterval(function () {
                var timeDiffInMinutes = getTimeDiffs(LatestEmailSentTime);
                if (timeDiffInMinutes >= 3) {
                    setStatus(false);
                    clearInterval(timerRef.current);
                }
                else {
                    setStatus(timeDiffInMinutes);
                    // setCountdown(Math.ceil((3 - timeDiffInMinutes) * 60));
                }
            }, 1000);
        }
    };
    useEffect(function () {
        if (emailSentTime === undefined) {
            return;
        }
        startTimer();
        return function () {
            clearInterval(timerRef.current);
        };
    }, []);
    var date = new Date(Number(emailSentTime));
    var hours = date.getHours().toString().padStart(2, '0');
    var minutes = date.getMinutes().toString().padStart(2, '0');
    var sentTime = "".concat(hours, ":").concat(minutes);
    return {
        startTimer: startTimer,
        sentTime: convertTimeToAmPm(sentTime),
        status: status,
        emailSentTime: emailSentTime,
    };
}
